export default {
title: 'AELU',
ssv: 'Visa keterampilan khusus',
what_ssv: 'Apa itu visa keterampilan  khusus?',
representative_message: 'Pesan Perwakilan',
aeru_feature: 'Ciri khas AELU',
aeru_how_to_use: 'Cara penggunaan',
aeru_q_a: 'Q&A',
aeru_function: 'Fungsi AELU',
aeru_fee: 'Biaya AELU',
login: 'login',
db_top_comment1: 'Situs pertama di industri !!   Situs Pelatihan Online Smartphone "Tes Visa Keterampilan Khusus"',
db_top_comment2: 'AELU adalah layanan Web yang mendukung perolehan visa keterampilan khusu dengan bertindak atas nama belajar untuk ujian, dan aplikasi.',
db_top_pr: 'Mari kita gunakan "visa keterampilan khusus"untuk rubut peluang baru.',
member_regist: 'Registrasi /Pendaftaran anggota',
registration_support_organization: 'Apa itu Agen pendukung pendaftaran?',
rso_dec1: 'Ada dua agen dalam sistem keterampilan khusus, " Agen yang berafiliasi dengan keterampilan khusu " dan " Agen pendukung pendaftaran".  Agen afiliasi keterampilan khusus adalah perusahaan (Agen penerima) yang mempekerjakan orang asing dengan keterampilan tertentu. Agen yang memiliki keahlian khusus harus memberikan dukungan kepada orang asing dengan keterampilan khusus di tempat kerja, kehidupan sehari-hari, dan masyarakat. ',
rso_dec2: 'Karena dukungan untuk orang asing dengan keterampilan khusus juga memikili konten khusus, mungkin sulit bagi perusahaan yang mempekerjakan orang asing dengan keterampilan khusus untuk menyediakannya.',
rso_dec3: 'Agen pendukung pendaftaran adalah agen yang dipercayakan kepada Agen afiliasi keterampilan tertentu untuk membuat dan menerapkan rencana dukungan bagi orang asing dengan keterampilan khusus.',
rso_dec4: 'Agen pendukungan pendaftaran akan memberikan semua dukungan berdasarkan Rencana Dukungan Orang Asing Keahlian No.1 yang Ditentukan di bawah kontrak pengiriman dukungan dengan agen penerima.',
rso_dec5: 'Untuk menjadi agen pendukung pendaftaran, harus didftarkan oleh Komisionar Badan Pengawas Imigrasi.',
rso_dec6: 'Agen yang terdaftar　akan　catatkan　dalam　register　pendukung　pendaftaran　dan　akan　diposting　di　situs　Badan　Pengebdalian Imigrasi.',
rso_dec7: 'Jangka waktu pendaftarannya selama 5 tahun dan perlu diperpanjang.',
rso_dec8: 'Agen pendukung pendaftaran diharuskan untuk membuat bebagai pemberitahuan kepada komisioner Badan Pengawan Imigrasi secara teratur atau sesekali.',
article1: 'Apa itu Visa keterampilan khusus?',
article1_dec1: 'Pada 8 Desember 2018, status kependudukan " keahlian khusus" baru ditetapkan karena berlakunya UU pengendalian Imigrasi yang telah direvisi.  Diterapkan pada April 2019.',
article1_dec2: 'Tetapkan status baru tempat tinggal # Keahlian khusu" dalam dua tahap. (No.1 , No.2)',
article1_dec3: 'Yang ditargetkan Industri adalah 14 jenis.',
article1_dec4: 'Persyaratan sasaran orang asing yang ditargetkan adalah orang yang punya "keterampilan yang membutuhkan pengetahuan atau pengalaman yang secukupnya". Dengan kata lain,orang yang ditargetkan adalah orang yang telah menyelesaikan 3 tahun pelatihan teknis atau yang telah lulus tes kemampuan dan bahasa Jepang yang setara.',
article1_dec5: '"Keterampilan khusus No. 1" diberikan status tempat tinggal hingga 5 tahun sebagai orang dengan keterampilan tertentu. Afiliasi keluarga tidak diperbolehkan.',
article1_dec6: 'Persyaratannya adalah harus lulus ujian untuk menjadi ahli dalam keterampilan khusus No.1.  (Perpanjangan masa tinggal memungkinkan untuk tempat tinggal hampir permanen dan aflikasi keluarga diperbolehkan.)',
article2: 'Pesan representatif',
article2_sub1: 'Jangan tinggalkan Jepang dulu.',
article2_dec1: 'Kami ingin mengucapkan terima kasih yang tulus kepada banyak trainee praktek kerja dan trainee yang kembali ke Jepang sebagai trainee praktek kerja, memperoleh keterampilan, dan tidak melakukan upaya apapun untuk pembangunan negara mereka sendiri. Menurutku penampilan berlatih demi keluarga dan untuk negara asalnya, yang tidak ada di Jepang saat ini, adalah penampilan manusia yang asli. Meskipun saya telah lama berkecimpung dalam bisnis pelatihan praktek kerja, tidak ada cara untuk memasuki negara hanya dengan visa trainee praktek kerja, dan saya memanfaatkan kesempatan itu, berlatih dengan kuat di Jepang, membuka bisnis di negara sendiri, dan negara saya berkembang pesat, saya melihat banyak hal. Namun, pada April 2019, visa "Visa Keterampilan Khusus" dibuat untuk memenuhi keinginan menikmati Jepang, yang tidak dapat dipelajari sepenuhnya dalam jumlah tahun yang ditentukan. Saya berharap banyak orang asing yang berkunjung ke Jepang yang memiliki ambisi di balik mata mereka, yang jarang ada di Jepang, dapat bersama-sama mengembangkan Jepang. Yang terpenting, saya ingin orang-orang seperti Jepang, menambah jumlah penduduk tetap, dan menciptakan masyarakat di mana mereka bisa hidup bersama.',
article2_dec2: 'PT MIERUKA / Visualisasi Co, Ltd',
article2_dec3: 'Direktur Perwakilan dan Presiden',
article2_dec4: 'Kazuhiko Horiuchi',
article3: 'Disediakan tiga ciri khas oleh AELU.',
article3_sub1: 'Studi ujian online',
article3_sub1_dec1: 'Disedakan sebagai pertanyaan semu sekitar 30 pertanyaan dari 14 jenis indusri oleh ahli, juga termasuk pertanyaan ujian masa lalu "AELU" yang jadi persiapan untuk tes keterampilan khusus dengan smartphon. Dapat mengambil tindakan sesering yang Anda suka sebelum pada hari ujian. Akan pasti lulus ujian jika Anda dapat nilai yang lebih dari ditentukan dalam pertanyaan yang dipilih oleh AI !',
article3_sub2: 'Informasi ujian',
article3_sub2_dec1: 'Informasi pengujian yang sangat sulit bagi pengunjung asing ke Jepang akan ditambahkan secara otomatis ketika informasi pengujian industri yang dipilih diperbarui',
article3_sub3: 'Agen aplikasi ujian',
article3_sub3_dec1: 'Seperti halnya informasi tes, saat melamar tes juga sangat sulit pendatang asing di Jepang untuk mengikuti ujian kecuali mereka mendaftar secara online. Ini adalah mekanisme yang memungkinkan Anda untuk mentransfer informasi pada saat pendaftaran, sudah memiliki formulir aplikasi, dan berlaku pada saat yang sama dengan pengumuman pengujian.',
article4: 'Pengenalan fungsi setelah lulus tes',
article4_sub1: 'Perayaan lulus ujian untuk magang teknis dalam negeri, yaitu cashback.(Tidak peduli apakah itu domestik atau asing)',
article4_sub1_dec1: 'Magang yang sudah tinggal di Jdpang menggunakan AELU, lulus , dan mengunggah nomor lulus dan sertifikat lulus ke layar penguna, Cash back gift tiket online senilai ,5,000 yen dari akun resmi LINE.(Jenis Email Amazon gift tiket,Googlepay iTune gift tiket)ggunanya, Cash back akan diberikan pada hari yang sama.  ',
article4_sub2: 'Kampanye rujuk teman.',
article4_sub2_dec1: 'Undang pelamar ke grup FB dari Jepang dan luar negeri, dan pengguna akan diberikan nomor manajemen mereka sendiri. Lalu cash back untuk orang yang terikat dengan nomor itu.  Satu bulan setelah bergabung, kami akan cash back 1,000 yen gift tiket oline kepada pengenal.',
article4_sub3: 'Setelah mendapatkan visa,pencari kerja secara otomtis cocok.(Binbang)',
article4_sub3_dec1: 'Setelah lulus tes sertifikasi menggunakan AELU, unggah dan Anda akan menerima penawaran otomatis dari semua perusahaan di Jepang. Wawancara juga dilakukan secara online, dan bahkan di bagian informal sebelumnya, Anda dapat terhubung secara online sehingga Anda dapt masuk dan pindah ke Jepang dengan percaya diri dan nulai bekerja.',
article4_sub4: 'Cash back dengan cek rutin kartu penduduk. (Binbang)',
article4_sub4_dec1: 'Jika Anda memeriksa kartu penduduk Anda sebulan sekali di AELU menggunakan aplikasi cek kartu penduduk " One Check Tab" , Anda akan mendapatkan uang tunai 10,000 yen dalam satu tahun.',
article5: 'Pengenalan fungsi khusus.',
article5_sub1: 'Anda dapat melihat pertanyaan yang telah Anda pecahkan.',
article5_sub1_dec1: 'Anda dapat mengakumulasi konten ujian yang telah Anda dilatih secara online dan menggunakan alat Anda sendiri, memahami kebiasaan pengguna dan mengatasi  pertanyaan yang tidak Anda kuasai. Sebab Anda dapat mempersiapkan ujian sesering yang Anda suka, tercatat semua riwayat skor dan waktu ujian, dan buatlah semirip mungkin pada hari jian yang sebenarnya. Selain itu, juga dapat lebih memahami pertanyaan karena ditulis dalam bahasa Anda sendiri dan bahasa Jepang.',
article5_sub2: 'Riwayat hidup yang waktu Anda masuk Jepang disimpan secara pelestarian permanen.',
article5_sub2_dec1: 'Ketika Anda mengajukan permohonan visa setelah lulus ujian keterampilan visa khusus, Anda harus memiliki resume yang waktu Anda masuk Jepang sebagai trainee praktek kerja.',
article5_sub3: 'Fungsi pendaftaran negara dan bidang Anda.',
article5_sub3_dec1: 'Karena bahasa negara Anda sendiri dan bahasa Jepang digunakan bersama, Anda dapat memahami pertanyaan dengan baik dan mengambil tindakan pencegahan. Tes sebenarnya hanya akan dilakukan dalam bahasa Jepang, sehingga Anda mengambil tindakan hanya dalam bahasa Jepang juga.',
article5_sub4: 'Pengingat persyaratan dan informasi ujian sertifikasi.',
article5_sub4_dec1: 'Ketika jadwal tes untuk pekerjaan yang diinginkan diunggah ke HP oleh masing-masing grup tes, itu akan diingatkan secara otomatis, pengguna akan diberitahu, tanggal tes akan diatur pada layar pengguna, dan pengatur waktu akan beroperasi secara otomatis.',
article5_sub5: 'Belajar menggunakan skrining.',
article5_sub5_dec1: 'Anda dapat mengekstrak titik lemah pengguna dan mempersiapkan ujian.',
article5_sub6: 'Konsultasi pembelajaran online dan wawancara menggunakan kamera smartphone.',
article5_sub6_dec1: 'Saat melanjutkan persiapan ujian sertifikasi menggunakan AELU, Anda akan dapat mengkomunikasikan makna dan maksud pertanyaan dalam panggilan online atau format obrolan.　Mungkin tidak diperlukan bagi mereka yang terbiasa dengan Jepang atau yang memiliki pemahaman yang baik tentang Jepang, tetapi layanan konsultasi panggilan dasar adalah cara teraman untuk konfirmasi pertanyaan apa pun sebelum ujian.',
article6: 'Biaya',
article6_sub1: 'Biaya pemakaian AELU.',
article6_sub1_dec1: 'Anda dapat belajar untuk ujian visa keterampilan khusus tanpa batasan apa pun. Anda dapat berkonsultasi secara online dalam bahasa ibu Anda. * Bisa juga digunakan sebagai juru bahasa selama waktu normal.  Pengumuman ke lokasi pengujian dimungkinkan pada hari pengujian. Anda dapat menyimpan resume Anda pada saat masuk selamanya. Setelah lulus ujian, cukup dapatkan nomor pas visa keterampilan dan perkenlkan pekerjaan yang Anda ingnkan. (Binbang)',
article6_sub2: 'Agen aplikasi ujian',
article6_sub2_dec1: 'Bagi Anda yang tidak bisa mendaftar ujian selama bekerja, kami akan bantu yaitu segera melamar saat informasi ujiana sertifikasi sudah tersedia agar Anda tidak ketinggalan tanggal ujian. Karena Anda tidak dapat mengikuti ujian sertifikasi kecuali Anda mendaftar.',
article7: 'Kampanye cashback sedang berlangsung!',
article7_dec1: 'Bagi mereka yang lulus ujian, mereka yang mendaftarkan nomor visanya di layanan ini akan menerima cash back 5,000 yen tanpa kecuali  !  Klik di sini untuk mengetahui cara berpartisipasi dalam kampanye.',
article8: 'Ayo daftar sekarang pada AELU!!',
dashboard: 'Dasbor',
member_info: 'Pendaftaran informasi profil',
first_name: 'Nama',
midle_name: 'nama tengah',
family_name: 'Nama keluarga / marga',
half_width_Roman: 'Alfabet roma',
password: 'kata sandi / password',
password_confirm: 'kata sandi / password (Konfirmasi)',
mail_adress: 'alamat email',
lineId: 'ID LINE',
country_id: 'Kode negara',
phone: 'nomor telepon',
issuing_country: 'Negara identifikasi / Pilihan Wilayah',
IDtype: 'Pilihan tipe ID',
residence_card: 'Kartu tempat tinggal atau kartu ID',
passport: 'paspor',
regist: 'Daftar',
is_required: 'Apakah wajib',
sign_up: 'Pendaftaran baru',
residence_front: 'Upload permukaan',
residence_back: 'Upload bagian belakang',
passport_upload: 'Upload  paspor',
error_file: 'Silahkan upload gambar',
post_resume: 'Pengajukan riwayat hidup.',
resume_upload: 'Upload riwayat hidup',
click_upload: 'Klik untuk mengupload',
image_drop: 'Atau seret dan jatukan file gambar',
select_language: 'Pilihan bahasa asli',
vietnamese: 'Bahasa Vietnam',
chinese: 'Bahasa Cina',
english: 'Bahasa Inggris',
khmer: 'Bahasa Khmer',
indonesian: 'bahasa Indonesia',
tagalog: 'Bahasa Tagalog',
burmese: 'Bahasa Birma',
hindu: 'Bahasa Hindu',
lao: 'Bahasa Lao',
mongolian: 'Bahasa Mongolia',
bengali: 'Bahasa Benggala',
sinhala: 'Bahasa Sinhala',
banglodesh: 'Bangkadesh',
malay: 'Bahasa Melayu',
nepali: 'Bahasa Nepal',
thai: 'Bahasa Thailand ',
japanese: 'Bahasa Jepang',
error_lang: 'Silakan pilih bahasa asli Anda.',
select_ouccupation: 'Seleksi pekerjaan',
select_max_three: 'Hingga 3 macam dapat dipilih.',
industry_id_1: 'Bisnis keperawatan',
industry_id_2: 'Industri pembersih gedung',
industry_id_3: 'Industri material',
industry_id_4: 'Manufaktur mesin industri',
industry_id_5: 'Industri terkait informasi listrik / elektronik',
industry_id_6: 'Industri konstruksi',
industry_id_7: 'Industri pembuatan kapal / kelautan',
industry_id_8: 'Industri perawatan mobil',
industry_id_9: 'Industri penerbangan',
industry_id_10: 'Industri akomodasi',
industry_id_11: 'Pertanian',
industry_id_12: 'Perikanan',
industry_id_13: 'Produksi minuman dan makanan',
industry_id_14: 'Bisnis restoran',
industry_id_15: "素形材・産業機械・電気電子情報関連製造業",
industry: 'Industri',
error_occupation: 'Silakan pilih pekerjaan satu atau lebih',
do: 'Melakukan',
news_tpic: 'Berita',
days_until_exam: 'Sisa hari hingga ujian',
estimated_pass_rate: 'Taksiran tingkat kelulusan',
average_score_taken: 'Skor rata-rata dari ujian yang diambil',
exam: 'Ujian adalah',
let_aim: 'Mari kita bidik……',
score: 'nilai/ skor',
solve_problem: 'Jawab pertanyaannya',
recommend_problem: 'Pertanyaan yang disarankan oleh AERU',
solved_problem: 'Pertanyaan yang dipecahkan di masa lalu',
looking_solved: 'Periksa pertanyaan masa lalu',
consultaion_service: 'Layanan konsultasi pembelajaran',
application_agency: 'Layanan aplikasi ujian',
billing: 'Penagihan',
more_look: 'Lihat lebih lanjut>',
more_look2: 'Lihat lebih lanjut',
facebook: 'Facebook',
google: 'Google',
until_not_account: 'Jika Anda belum memiliki akun,',
or: 'Atau',
other_way: 'dengan cara lain',
not_have_account: 'Jika Anda belum memiliki akun,',
have_account: 'Jika Anda memiliki akun,',
forgot_password: 'Jika Anda lupa kata sandi / password',
this: 'Sini',
at_login: 'login dengan',
pass_condition: '8 karakter dan simbol alfanumerik satu byte',
at_sign_up: 'Pendaftaran baru dengan',
agreement1: 'Dengan menyetujui yang berikut dan memilih untuk melanjutkan ,AELU',
terms: 'Ketentuan layanan',
agreement2: 'menyetujui dengan',
agree: 'menyetujui dan dilanjutkan',
account_confirm: 'Kode konfirmasi',
confirm: 'Konfirmasi',
not_confirm: 'Kode konfirmasi belum dikonfirmasi.',
move_confiirm: 'Pindah ke layar input kode konfirmasi',
top: 'Teratas',
news_list: 'Daftar berita',
problim_list: 'Daftar pertanyaan',
learning_consul: 'Konsultasi pembelajaran',
agency: 'Informasi pengujian',
of_trend: 'Tentang tren Ujian',
start_test: 'Mulai tes',
study_mode: 'Mode pembelajaran',
order_question: 'Pertanyaan',
of_question: 'Dalam pertanyaan',
question_current: 'Jawaban yang benar',
to_mypage: 'ke My page',
correct_answer: 'Jawaban benar!',
correct_answer_normal: 'Jawaban benar!',
no_correct_answer: 'Jawaban yang salah',
next: 'ke pertanyaan berikut',
finish_all: 'Menjawab semua pertanyaan',
your_score: 'nilai anda',
is: 'adalah!',
result_description: 'Dapat dipecahkan pertanyaan lain dari "Lihat daftar pertanyaan". Juga dapat meninjau pertanyaan yang telah Anda pecahkan sebelumnya dari halaman daftar masalah.',
back_quiz_list: 'Lihat daftar pertanyaan',
retry: 'Pecahkan pertanyaan ini lagi',
no_description: 'Tidak ada komentar',
show_ans: 'Lihat jawabannya',
of_solved_problem: 'pertanyaan yang dipecahkan masa lalu',
of_solved_problem_list: 'Daftar pertanyaan yang dipecahkan di masa lalu',
solved_description: 'Anda dapat ulasan tes pembelajaran untuk ujian visa keterampilan khusus di industri perawatan.',
before_result: 'Hasil terakhir',
looking_back: 'Ulasan',
back_solved_problem_list: 'Lihat pendaftaran pertanyaan yang di pecahkan masa lalu',
again_retry: 'sakali lagi ulasan pertanyaan ini',
done_member_regist: 'Terima kasih telah mendaftar sbagai angota.',
done_member_regist_description: 'Setiap layanan akan tersedia setelah Anda membayar biaya penggunaan layanan.  Harap daftarkan informasi pembayaran Anda.',
choose_payment: 'Pilih cara pembayaran',
service_content: 'Isi layanan',
test_info_service: 'Layanan informasi ujian',
usage_fee: 'biaya pemakaian',
test_fee: '500yen + Pajak',
application_fee: '20,000yen  + Pajak',
method_payment: 'cara pembayaran',
LINE_pay: 'LINE Pay',
line_pay_description: '* Simpan gambar kode QR dan lakukan pembayaran dalam layanan LINE Pay. Ketika membayar dengan LINE Pay, akan butuh waktu bagi operator untuk konfirmasi.',
save_qr: 'Simpan kode QR',
next_stage: 'lanjut',
credit_card: 'kartu kredit',
copmplete_payment: 'Pembayaran selesai.',
copmplete_payment_descript: 'Sekarang Anda dapat menggunakan fungsi studi ujian online, informasi ujian, dan layanan agen aplikasi ujian karena sudah selesai pembayarannya.',
start_sevice: 'Mulai gunakan layanan',
to_payment: 'Ke layar pembayaran',
of_news_list: 'Daftar berita',
done_payment: 'Pembayaran telah selesai.',
tv_consult: 'Konsultasi telepon TV',
tell_consult: 'Konsultasi melalui telepon',
learning_consul_descript01: 'Aplikasi ujian',
learning_consul_descript02: 'Kami akan bertindakan atas nama Anda.',
money_unit: 'Yen',
learning_consul_unit: 'Satu kali',
fault_payment1: 'Gagal pembayaran',
fault_payment2: 'Silahkan dicoba lagi.',
no_examination: 'Belum ada ',
no_exam: 'Belum ada ujian',
undecided: 'bimbang',
retry_login: 'Silahkan login lagi.',
no_problem: 'Tidak ada pertanyaan yang dipecahkan.',
do_problem: 'Pecahkan pertanyaan.',
qa_title: 'Pertanyaan yang sering diajukan.',
search_category: 'Persempit menurut kategori.',
search_freeward: 'Cari dengan kata bebas / Freeword',
test_result: 'Hasil ujian latihan.',
to_top: 'Ke atas',
missPassword: 'Salah kata sandi / password atau alamat email.',
sample_problem: 'Mari kita mengalami belajar untuk ujian online.',
exercises: 'Pertanyaan latihan.',
let_exercises: 'Mari kita coba dipecahkan satu pertanyaan !!',
to_qa: 'Lihat Q&A lagi',
read_more: 'Lihat lagi',
account_setting: 'Pengaturan akun',
profile_setting: 'Pengaturan profil',
notification_setting: 'Pengaturan pemberithuan',
logout: 'Keluar / logout',
changeEmail: 'Ganti alamat email',
changePassword: 'Ganti kata sandi / password',
change: 'Ganti / Rubah',
save: 'Simpan',
change_success: 'Bisa dirubah',
now_password: 'Kata sandi / Password sekarang',
new_password: 'Kata sandi / Password baru',
check_new_password: 'Kata sandi / Password baru (Konfirmasi)',
do_logout: 'Keluar / logout',
done_learning_consul_payment: 'Pembayaran sudah selesai',
past_exam: 'Pertanyaan masa lalu',
update_info: 'Memperbarui informasi terbaru',
official_sns: 'SNS Resmi',
privacy_policy: 'Rahasia pribadi',
terms_service: 'Persyaratan layanan',
transaction_law: 'Notasi berdasarkan UU Transaksi Hukum Komersial Tertentu.',
selectCountry: 'Pilih satu negara',
goInquiry: 'Lanjutkan ke pertanyaan',
lineInquiry: 'Hubungi kami melalui LINE.',
regist_accept_certificate: 'Pendaftaran sertifikat lulus perolehan visa keahlian khusus.',
accept_certificate_description: 'Anda dapat mendaftarkan sertifikat dan nomor lulus.',
accept_certificate: 'Surat sertifikat',
accept_number: 'Nomor lulus',
immigration_resume: 'Pendaftaran riwayat hidup pada saat masuk Jepang',
resendCode: 'Kirim ulang kode konfirmasi',
line_at_register: 'Pertanyaan tentang layanan melalui LINE@',
study: 'Silahkan upload riwayat hidup Anda.',
study_text: 'Download teks pembelajaran',
do_resume_update: 'Silahkan upload riwayat hidup Anda.',
done_resume_update: 'Terima kasih telah mendaftarkan riwayat hidup Anda !!',
regist_resume_enter: 'Pendaftaran riwayat hidup entri.',
about_company: 'Tentang perusahaan operasi.',
add_exam_info_detail: 'Ditambahkan informasi Ujian. Klik di sini untuk ketelitian / detail dan aplikasi.',
regist_result_get_money: 'Daftarkan Hasil ujian Anda dan dapatkan uang',
detail: 'Ketelitian / Detail',
about_withdrawal_subsc: 'Tentang penarikan, pembayaran reguler, dan berhenti berlangganan.',
apply_withdrawal: 'Aplikasi untuk prosedur penarilan.',
apply_subsc: 'Aplikasi untuk pembatalan berlangganan',
about_withdrawal: 'Aplikasi penarikan.',
about_subsc: 'Berhenti berlangganan',
exam_info: 'Informasi pengujian,',
date: 'Tanggal dan waktu',
day: 'Hari',
place: 'Tempat',
result_publication: 'publikasi hasil',
result_publication_place: 'Tempat untuk mengumumkan hasilnya',
result_this_page: 'Akan diumumkan di halaman ini',
exam_way: 'Format ujian',
exam_way2: 'Format pertanyaan ujian,',
include_exam_fee: 'Termasuk biaya ujian,',
exam_application_desc: 'Pengiriman formulir aplikasi untuk ujian \ nKomunikasi dengan sekretariat ujian \ nMenghubungi apa yang harus dipersiapkan hari ini (LINE @) \ nKonsultasi untuk pertanyaan apa pun terkait ujian,',
self_application: 'Lamar sendiri,',
application_method: 'Bagaimana menerapkan,',
under_this_url: 'Silakan mendaftar dari URL berikut,',
do_appliction: 'Ajukan permohonan ujian,',
study_with_aeru: 'Gunakan fungsi belajar ujian dari halaman atas untuk meningkatkan tingkat kelulusan,',
line_at_consul: 'LINE @ layanan konsultasi pembelajaran,',
instagram: 'Instagram,',
do_signup: 'Anda telah diautentikasi. \ nSilakan masuk lagi.,',
gender: 'Jenis kelamin',
man: 'Pria',
woman: 'Wanita',
input_problem_title: 'Berisi judul pertanyaan ...,',
still_no_problem: 'Tidak ada pertanyaan',
enter_in_problem_trend: 'Berisi penjelasan singkat soal ujian, seperti tren soal ujian selama ini dan format jawaban (jenis pilihan).,',
correct: 'Jawaban yang benar,',
explanation: 'Komentar,',
problem: 'pertanyaan',
do_nursing_not_published: 'Ujian sedang dilakukan di industri asuhan keperawatan, tetapi pertanyaan sebelumnya belum dipublikasikan.,',
practical_exam_of_year: 'Ujian praktek tahun,',
judgment_test_of_year: 'Ujian Penghakiman 2019,',
judgment_test_answer_of_year: 'Jawaban Ujian Penghakiman 2019,',
not_yet_test_material: 'Belum teruji di industri bahan baku,',
not_yet_test_machinery: 'Belum teruji di sektor manufaktur mesin industri,',
not_yet_test_electronic: 'Belum teruji dalam industri informasi kelistrikan dan elektronik,',
not_yet_test_construction: 'Belum teruji di sektor konstruksi,',
not_yet_test_shipbuilding: 'Belum diuji di industri galangan kapal dan kelautan,',
do_automobile_not_published: 'Pemeriksaan sedang dilakukan di industri perawatan mobil, tetapi pertanyaan sebelumnya belum dipublikasikan.,',
do_aviation_not_published: 'Ujian sedang dilakukan di industri penerbangan, tetapi pertanyaan sebelumnya belum dipublikasikan.,',
do_agricultural_not_published: 'Ujian sedang dilakukan di sektor pertanian, tetapi pertanyaan sebelumnya belum dipublikasikan.,',
do_fishery_not_published: 'Pengujian sedang dilakukan di bidang perikanan, tetapi pertanyaan sebelumnya belum dipublikasikan.,',
do_food_not_published: 'Pemeriksaan telah dilakukan di industri manufaktur makanan dan minuman, tetapi pertanyaan sebelumnya belum dipublikasikan.,',
do_restaurant_not_published: 'Ujian sedang dilakukan di industri restoran, tetapi pertanyaan sebelumnya belum dipublikasikan.,',
schedule_undecided: '(* Jadwal belum diputuskan),',
year: 'Tahun',
month: 'Bulan',
texts_learning: 'Buku teks untuk mempelajari setiap industri.',
texts_learning_test: 'Buku teks untuk belajar tes evaluasi keterampilan khusus (Jepang)',
skill_test_sample: 'Sampel tes evaluasi kemahiran,',
japanese_test_sample: 'Sampel tes evaluasi Jepang ,',
not_building_texts: 'Belum ada buku teks pembelajaran untuk industri pembersih gedung ,',
not_material_texts: 'Belum ada teks pembelajaran di bidang industri material ,',
not_machinery_texts: 'Belum ada teks pembelajaran di bidang manufaktur mesin industri ,',
not_electronic_texts: 'Belum ada buku teks pembelajaran untuk industri terkait informasi kelistrikan dan elektronik ,',
not_shipbuilding_texts: 'Belum ada buku teks pembelajaran untuk industri galangan kapal / kelautan ,',
not_automobile_texts: 'Belum ada buku teks pembelajaran untuk industri perawatan mobil ,',
not_accommodation_texts: 'Belum ada buku teks studi untuk industri akomodasi ,',
not_food_texts: 'Belum ada buku teks pembelajaran untuk industri manufaktur makanan dan minuman ,',
not_restaurant_texts: 'Teks pembelajaran tes keterampilan makan dan minum ,',
each_depertment_texts: 'Buku teks untuk studi ujian masing-masing departemen ,',
skill_test_basic: 'Teks pembelajaran tes evaluasi keterampilan (teknologi dasar) ,',
skill_test_safety: 'Teks pembelajaran tes evaluasi keterampilan (keselamatan / kualitas kerja) ,',
skill_test_aircraft: 'Teks pembelajaran tes evaluasi keterampilan (gambaran pesawat) ,',
texts_livestock: '[Buku teks untuk belajar beternak] versi Jepang ,',
texts_cultivated: '[Teks untuk mempelajari tentang pertanian yang dibudidayakan] versi Jepang ,',
skill_test_fishery: 'Tes pengukuran keterampilan perikanan (memancing) ,',
skill_test_general_fishery: 'Tes pengukuran keterampilan perikanan (perikanan umum) ,',
skill_test_safety_fishery: 'Tes pengukuran keterampilan perikanan (keamanan perikanan) ,',
skill_test_specialty_fishery: 'Tes pengukuran keterampilan perikanan (terkait jaringan khusus perikanan) ,',
skill_test_related_fishery: 'Tes pengukuran keterampilan perikanan (penangkapan ikan terkait penangkapan) ,',
skill_test_aquaculture: 'Tes pengukuran keterampilan perikanan (pertanian) ,',
skill_test_general_aquaculture: 'Tes pengukuran keterampilan perikanan (pertanian umum dan aman) ,',
skill_test_feeding_aquaculture: 'Tes pengukuran keterampilan perikanan (terkait pakan dan budidaya) ,',
skill_test_non_feeding_aquaculture: 'Tes pengukuran keterampilan perikanan (terkait dengan budidaya tidak diberi makan) ,',
registration_skill_visa: 'Pendaftaran sertifikat penerimaan visa keterampilan khusus,',
please_register_pdf_number: 'Silakan daftarkan foto atau PDF sertifikat lulus untuk mendapatkan visa keterampilan khusus dan nomor pas pada sertifikat lulus.,',
regist_and_get_cash_bag: 'Jika Anda mendaftar sekarang, Anda bisa mendapatkan 5.000 yen dengan kantong uang tunai,',
thank_you_regist_visa_pass: 'Terima kasih telah mendaftarkan sertifikat pas untuk mendapatkan visa keahlian khusus!,',
exam_info_detail: 'Garis besar implementasi tes',
em_exam_detail_language: 'Dijadwalkan akan diberikan dalam bahasa lokal',
em_exam_detail_method: 'Ujian mata pelajaran, Ujian praktek',
em_exam_detail_way: 'Pengujian berbasis komputer (CBT) Metode pengujian kertas atau metode pengujian kerja seperti manufaktur',
em_exam_detail_section: '19 Kategori pengujian (pengecoran, penempaan, pengecoran mati, permesinan, pengepresan logam, pekerjaan besi, lembaran logam pabrik, pelapisan, anodisasi aluminium, penyelesaian, inspeksi mekanis, perawatan mesin, perakitan peralatan elektronik, perakitan peralatan listrik, pembuatan papan kabel cetak, Cetakan plastik, pengecatan, pengelasan, kemasan industri)',
em_exam_detail_notify: 'Setelah tes, kirim pemberitahuan hasil melalui email',
em_exam_detail_border: 'Ujian mata pelajaran: 65% atau lebih \ n Ujian Praktis: 60 poin atau lebih',
ss_exam_detail_language: 'Bahasa Jepang',
ss_exam_detail_method: 'Tes kecakapan dilakukan dengan tes keterampilan praktis dan tes mata pelajaran. \ n Ujian praktis dilaksanakan untuk setiap kategori bisnis. \ n Tes subjek dilakukan untuk setiap kategori bisnis dengan metode tes kertas.',
ss_exam_detail_way: 'Metode uji kertas, dll.',
ss_exam_detail_section: 'Jurusan / Keterampilan Praktis / Keterampilan: Pengelasan, pengecatan, pengerjaan besi, finishing, permesinan, perakitan peralatan listrik',
ss_exam_detail_notify: '-',
ss_exam_detail_border: 'Tes subjek: 60% atau lebih \ n Tes praktek: Penilaian berdasarkan hasil praktek',
c_exam_detail_language: 'Bahasa Jepang',
c_exam_detail_method: 'Tes kecakapan dilakukan dengan tes keterampilan praktis dan tes mata pelajaran.',
c_exam_detail_way: 'Pengujian berbasis komputer (CBT), tes praktik adalah metode yang ditentukan oleh perusahaan terdaftar',
c_exam_detail_section: '-',
c_exam_detail_notify: 'Dipublikasikan di beranda',
c_exam_detail_border: 'Ujian subjek: 65% atau lebih \ n Ujian praktek: Penilaian berdasarkan hasil praktek',
cm_exam_detail_language: 'Bahasa Jepang',
cm_exam_detail_method: 'Ujian kecakapan dilakukan dengan ujian keterampilan praktis dan ujian mata pelajaran.',
cm_exam_detail_way: 'Lakukan ujian akademik dan praktis dengan pengujian berbasis komputer (CBT)',
cm_exam_detail_section: 'Mata pelajaran ujian mata pelajaran \ n Pengetahuan dasar tentang struktur, fungsi dan metode penanganan \ nB. Pengetahuan dasar tentang inspeksi, perbaikan dan penyesuaian \ nC. Pengetahuan dasar tentang struktur, fungsi dan metode penanganan mesin uji, alat ukur dan alat untuk perawatan. \ n Pengetahuan dasar tentang sifat dan penggunaan bahan, bahan bakar, dan lemak \ nSubjek ujian praktis \ nPekerjaan dasar yang sederhana \ nB Pembongkaran, perakitan, pemeriksaan dan penyesuaian sederhana \ nC Perbaikan mudah \ nD Mudah Penanganan mesin uji perawatan, alat ukur dan alat',
cm_exam_detail_notify: '--',
cm_exam_detail_border: 'Ujian mata pelajaran: 65% atau lebih \ n Ujian Praktis: Skor total 60% atau lebih',
a_exam_detail_language: 'Bahasa daerah dan bahasa Jepang',
a_exam_detail_way: 'Pengujian berbasis komputer (CBT), metode pengujian kertas',
a_exam_detail_section: '① Departemen pertanian budidaya secara umum, keselamatan dan kesehatan, varietas / karakteristik tanaman budidaya, lingkungan budidaya (fasilitas / peralatan / bahan / mesin), metode budidaya / pengelolaan, pengendalian hama / gulma, pemanenan / penyesuaian / penyimpanan / pengiriman ②Pengamatan tanah praktis , Penanganan pupuk / pestisida, penanganan benih, pengelolaan lingkungan, penanganan bahan / peralatan / mesin, pekerjaan yang berhubungan dengan budidaya, keselamatan dan kesehatan ③ Bahasa Jepang Mendengar isi dari pekerjaan pertanian dalam bahasa Jepang',
a_exam_detail_notify: 'Dipublikasikan di beranda',
a_exam_detail_border: 'Terhadap skor total harus melebihi poin referensi penilaian yang ditetapkan oleh Kamar Pertanian Nasiona.',
avi_exam_detail_method: 'Ujian kecakapan dilakukan dengan ujian keterampilan praktis dan ujian mata pelajaran.',
avi_exam_detail_section: 'Pertanyaan akan diberikan dari teks yang diposting di situs web Asosiasi Teknologi Penerbangan Jepang.',
avi_exam_detail_notify: '--',
avi_exam_detail_border: 'Ujian mata pelajaran: 65% atau lebih \ n Ujian Praktis: Skor total 65% atau lebih',
f_exam_detail_language: 'Bahasa Jepang',
f_exam_detail_method: 'Ujian kecakapan dilakukan dengan ujian keterampilan praktis dan ujian mata pelajaran.',
f_exam_detail_way: 'Lakukan ujian akademik dan praktis dengan pengujian berbasis komputer (CBT)',
f_exam_detail_section: 'Subjek uji harus memastikan bahwa tingkat pekerjaan tertentu di bidang perikanan (perikanan) atau bidang perikanan (budidaya) dapat dilakukan secara akurat dengan memahami instruksi pengawas, atau dapat dilakukan atas kebijaksanaannya sendiri.',
f_exam_detail_notify: 'Dipublikasikan di beranda',
f_exam_detail_border: 'Mereka yang skor total tes tertulis dan tes keterampilan praktis melebihi poin referensi penilaian yang ditetapkan oleh badan pelaksana tes profisiensi akan diterima.',
no_exam_info: 'Belum ada informasi ringkasan tes yang dirilis',
language: 'Bahasa implementasi',
method: 'Metode implementasi',
way: 'Metode implementasi',
section: 'Kategori tes',
notify: 'Pemberitahuan hasil tes',
border: 'Kriteria hasil tes',
go_line_at: 'Ke LINE @',
thank_you_and_deactivate: 'Terima kasih. \ nUntuk prosedur penarikan dari layanan, silakan masukkan prosedur penarikan dari baris @ jendela di bawah ini. \ nUntuk pembatalan pembayaran biasa, masukkan pembatalan pembayaran reguler dari baris @ jendela berikut. \ n Kami akan memproses segera setelah kami mendapatkan konfirmasi',
thank_you_and_subscribe: 'Terima kasih. \ nUntuk pembatalan pembayaran biasa, masukkan pembatalan pembayaran reguler dari baris @ jendela berikut. \ n Kami akan membatalkan kontrak segera setelah kami menerima konfirmasi.',
ten_thousand_yen: 'Sepuluh ribu yen',
yen_per_month: 'Yen / bulan',
how_to_use_this_service: 'Cara penggunaan',
selecting_a_browser: 'Pemilihan browser',
selecting_a_browser_dec: 'Akses https // aelu.co.jp dengan browser (Google chrome, Safari, edge, dll.) * Tidak ada aplikasi',
provisional_registration: 'Pendaftaran sementara',
provisional_registration_dec: 'Masuk dengan Facebook atau ID Google Anda atau daftar dengan alamat email Anda. Setelah memilih bahasa yang diinginkan dan pekerjaan yang diinginkan, Anda dapat menelusuri konten tiruan ujian sertifikasi online.',
full_registration: 'Pendaftaran utama',
full_registration_dec: 'Klik &quot;Pendaftaran&quot; pada halaman konten ujian sertifikasi online, isi informasi yang diperlukan, dan gunakan semua layanan termasuk 14 soal latihan ujian sertifikasi industri.',
name_validate_message: 'Harap masukkan informasi dengan ejaan yang sama seperti yang tertera di paspor Anda',
live_at_area: 'Area tempat tinggal saat ini',
agency_application: 'Bertindak untuk aplikasi ujian.',
mypage: 'halmanku',
myanmar: 'Birma',
exam_list: 'Daftar jadwal ujian',
no: 'ke-',
times: 'kali',
application_start: 'Mulai aplikasi',
application_end: 'Aplikasi telah ditutup.',
enforcement: 'Penerapan',
applicated: 'Telah sudah aplikasi',
reception_time: 'waktu penerimaan',
announthment_d: 'Tanggal pengumuman penerimaan.',
reception_period: 'Jangka waktu lamaran.',
detail_link: 'lihat detailnya',
exam_country: 'Negara tuan rumah',
line: 'LINE',
vietnum: 'Vietnam',
laos: 'Raos',
malaysia: 'Malaysia',
bangladesh: 'Bangladesh',
indo: 'India',
nepal: 'Nepal',
mongol: 'Mongolia',
indonesia: 'Indonesia',
th: 'Thailand',
philipine: 'Filipina',
my: 'Myanmar',
uzbekistan: 'Uzbekistan',
pakistan: 'Pakisutan',
japan: 'Jepang',
news_title: 'Berita mengunai Visa keterampilan khusus',
missNowPassword: 'Kata sandi saat ini salah.',
article6_sub2_dec2: 'Jika Anda mendaftar di sini, kami juga akan mengumumkan aplikasi dan harga ujian dan tempatnya hingga hari ujian.',
create_naw_password: 'gant kata sandi / password',
send_confirmcode: 'Kode konfirmasi telah dikirim.',
edit: 'ganti',
success_new_password_setting: 'Telah menyetel kata sandi / password baru.',
error_email: 'Ini adalah alamat email yang tidak terdaftar.',

click_here_businesses: "&quot;Klik di sini untuk bisnis&quot",
regist_organization_staff_info: "Pendaftaran informasi bisnis / pengguna",
organization_info: "Informasi bisnis",
staff_info: "Informasi pengguna",
org_name: "Nama Bisnis",
url: "URL",
org_scale: "skala",
org_zip: "Kode Pos",
org_adress1: "Prefektur",
org_adress2: "Kota",
org_adress3: "Alamat / Nama Apartemen",
org_industry: "Industri",
org_category: "Kategori",
org_description: "Deskripsi",
org_established_at: "Tahun pendirian",
org_phone: "Nomor telepon bisnis",
failed_established_at: "Tanggal tidak berlaku. ",
staff_name: "nama pengguna",
form_miss: "Ada kesalahan dalam formulir input. ",

back_joboffer_detail: "Kembali ke detail pekerjaan <",
create_joboffer: "Buat pekerjaan",
edit_joboffer: "Edit Pekerjaan",
stop_posting: "Berhenti memposting",
delete: "&quot;menghapus&quot",
job_title: "Judul pekerjaan",
job_catch_phrase: "Pekerjaan Tangkap Salinan",
job_category: "Kategori pekerjaan",
employed_company_name: "Nama perusahaan yang dipekerjakan",
work_location: "Tempat kerja",
employment_status: "Status Pekerjaan",
full_time_employee: "Pegawai biasa",
part_time_job: "pekerjaan paruh waktu",
temporary_staff: "Pekerja dikirim",
contract_employee: "Pegawai kontrak",
intern: "Magang",
subcontracting: "Subkontrak",
contract: "Kontrak",
new_graduate: "Lulusan baru",
salary: "Gaji",
annual_income: "pendapatan tahunan",
monthly_salary: "Gaji bulanan",
weekly_salary: "Gaji mingguan",
dayly_salary: "Gaji harian",
job_offer_attension1: "Hal ini diperlukan untuk menentukan kondisi kerja yang ditentukan dll sesuai dengan hukum untuk konten pekerjaan",
job_offer_attension2: "Silakan periksa kondisi kerja, dll. yang harus dinyatakan dengan jelas oleh hukum, dan kemudian jelaskan konten pekerjaan. (Referensi: Kementerian Kesehatan, Tenaga Kerja dan Kesejahteraan, Biro Tenaga Kerja Prefektur &quot;Kepada semua perusahaan yang merekrut pekerja&quot;)",
job_offer_attension3: "Anda mungkin tidak dapat memposting pekerjaan jika menggunakan bahasa yang membatasi usia, jenis kelamin, atau status sosial target. ",
job_offer_attension4: "Contoh yang sering tidak dipublikasikan: &quot;Selamat datang di usia 20-an&quot; &quot;Selamat datang di kalangan anak muda&quot; &quot;Selamat datang wanita / terbatas&quot; &quot;Hanya pelajar&quot;",
work_content_appeal: "Konten pekerjaan dan poin banding",
work_content_appeal_desc: "Akan lebih mudah bagi pencari kerja untuk tertarik jika Anda memberi tahu mereka poin bandingnya terlebih dahulu. ",
human_resources_seek: "Sumber daya manusia untuk dicari",
human_resources_seek_desc: "Tidak hanya keterampilan yang Anda cari, tetapi juga informasi yang memungkinkan pencari kerja membayangkan tempat kerja. ",
working_hours: "Jam kerja",
traffic_access: "Akses lalu lintas",
traffic_access_desc: "Tidak hanya informasi angkutan umum, tetapi juga perjalanan dengan mobil, apakah ada tempat parkir untuk karyawan, dll. ",
required: "Yg dibutuhkan",
optional: "Apa saja",
other: "Lain",
photo: "Foto",
upload_video: "Mengunggah video",
job_tag: "Tanda Pekerjaan",
until_select_three: "Hingga 3 dapat dipilih",
senior_support: "Dukungan senior",
salary_increase_promotion: "Peningkatan gaji/promosi tersedia",
no_overtime: "Tidak ada lembur",
target_hiring_time: "Waktu target rekrutmen",
additional_questions: "Pertanyaan tambahan",
job_offer_title: "Nama Pekerjaan",
public: "Melepaskan",
private: "pribadi",
public_status: "Status publik",
occupation: "Pendudukan",
walfare: "Pengobatan / Manfaat",
create: "&quot;membuat&quot",
hour: "Waktu",
back_mypage: "Kembali ke Halaman Saya <",
job_offers: "daftar pekerjaan",
look_matches: "Lihat daftar pertandingan",
now_public: "Sekarang buka",
now_private: "Tidak diterbitkan",
check: "Konfirmasi",
edit2: "Untuk mengedit",
news_detail: "Rincian berita",
prefectures: "Prefektur",

hokkaido: "Hokkaido",
aomori: "Aomori",
iwate: "Iwate",
miyagi: "Miyagi",
akita: "Akita",
yamagata: "Yamagata",
fukushima: "Fukushima",
ibaraki: "Ibaraki",
tochigi: "Tochigi",
gunma: "Guna",
saitama: "Saitama",
chiba: "Chiba",
tokyo: "Tokyo",
kanagawa: "Kanagawa",
niigata: "Niigata",
toyama: "&quot;Toyama&quot",
ishikawa: "Ishikawa",
fukui: "Fuki",
yamanashi: "Yamanashi",
nagano: "Nagano",
gifu: "Gif",
shizuoka: "Shizuoka",
aichi: "Aichi",
mie: "Tiga kali",
shiga: "Shiga",
kyoto: "Kyoto",
osaka: "Osaka",
hyogo: "Hyogo",
nara: "Nara",
wakayama: "Wakayama",
tottori: "Tottori",
shimane: "Shiman",
okayama: "Okeama",
hiroshima: "Hiroshima",
yamaguti: "Yamaguchi",
tokushima: "Tokushima",
kagawa: "Kagawa",
echime: "Ehime",
kochi: "Kochi",
fukuoka: "Fukuoka",
saga: "Kisah",
nagasaki: "&quot;Nagasaki&quot",
kumamoto: "Kumamoto",
oita: "Oita",
miyazaki: "Miyazaki",
kagoshima: "Kagoshima",
okinawa: "Okinawa",
sinhalese: "Sinhala",
exam_region: "Prefektur",
exam_place_list: "Daftar tempat",
exam_place_name: "Nama tempat ujian",
care_evaluation_test: "Tes evaluasi pelatihan keterampilan perawatan jangka panjang",
clean_building_test: "Membangun industri pembersih masalah masa lalu",
answer: "menjawab",
skill_test_measurement: "Tes pengukuran keterampilan",
exam_problem: "soal ujian",
fields: "Ladang dan sayuran",
gardening: "Fasilitas berkebun",
mushroom: "jamur",
fruit: "Pohon buah",
dairy: "susu",
poultry: "Unggas",
pig: "Peternakan babi",
beginner: "Pemula",
professional: "Tingkat profesional",
advanced: "Maju",
technical_training_test: "Tes evaluasi pelatihan magang teknis",
exam_part: "Bagian dari pertanyaan ujian",
tokoha_fruit: "Pohon Buah Tokoha",
deciduous_fruit: "Pohon buah gugur",
ver: "Edisi",
errata: "salah",
form_work: "Konstruksi bekisting",
construction: "Memplester",
tunnel_line: "Jalur propulsi terowongan",
earth_work: "Pekerjaan tanah",
loofing: "Atap",
elecommunication: "telekomunikasi",
reinforcing_contstruction: "Memperkuat konstruksi bar",
reinforcing_joint: "Memperkuat sambungan batang",
wall_painting: "Lukisan (penutup dinding)",
board_finish: "Finish papan, finishing interior",
steeplejack: "Tobi",
spray_insulation: "Insulasi uretan yang disemprotkan",
marine_civil: "Teknik Sipil Kelautan",
concrete_pumping: "Pemompaan beton",
construction_machinery: "Konstruksi Mesin Konstruksi",
learning_text: "Mempelajari teks",

basic_aircraft: "Kesimpulan teknologi pesawat dasar, pengukuran listrik",
worksafety_quality: "Keselamatan kerja, kualitas",
aircraft_overview: "Ikhtisar pesawat",
fish_general: "Perikanan pada umumnya",
fish_safety: "Keamanan Perikanan",
network_relations: "Kelas Khusus Perikanan",
fish_relations: "Terkait perikanan khusus perikanan",
aquaculture_general: "Akuakultur pada umumnya",
feeding_aquaculture: "Pemberian makan khusus akuakultur dan terkait akuakultur",
unfed_aquaculture: "Khusus akuakultur terkait akuakultur yang tidak diberi pakan",
attachment: "Lampiran",
glossary: "Glosarium",
feneral_customer: "Layanan pelanggan umum",
food_dring_cooking: "Memasak makanan dan minuman",
hygiene_management: "manajemen kebersihan",
visa_application: "Aplikasi untuk visa keahlian khusus",
certificate_residence_tax: "1. Sertifikat pajak tempat tinggal (untuk tahun terakhir)",
salary_income_withholding : "2. Fotokopi slip pemotongan pendapatan gaji",
national_health_insured: "3. Fotokopi kartu peserta Jaminan Kesehatan Nasional (jika orang tersebut terdaftar)",
national_health_payment: "4. Sertifikat Pembayaran Premi Jaminan Kesehatan Nasional",
national_health_receipt: "5. Fotokopi Kwitansi Premi Jaminan Kesehatan Nasional",

technical_intern_training2: "6. Dokumen yang menyatakan bahwa pelatihan magang teknis No. 2 telah berhasil diselesaikan",
need_the_following : "Anda memerlukan salah satu dari berikut ini: ",
pass_certificate_test_specialized : "・ Salinan sertifikat kelulusan tes keterampilan praktis dari tes evaluasi keterampilan (kelas khusus)",
technical_intern_training3: "・ Salinan sertifikat kelulusan tes praktik tes keterampilan (kelas 3)",
evaluation_record_technical_intern: "・ Jika Anda tidak lulus ujian di atas, Anda harus mengisi catatan evaluasi untuk trainee praktek kerja. ",
cartificate_pass_basic_test: "Sebagai alternatif untuk 7.6, Anda dapat mengirimkan salinan sertifikat kelulusan dari Japan Foundation Japanese Basic Test atau salinan sertifikat kelulusan dari Japanese Language Proficiency Test (N4) atau lebih tinggi. ",
change_permission_application: "8. Foto permohonan izin perubahan (vertikal 4 cm x horizontal 3 cm)",
resume_data_time_entry: "9. Lanjutkan data pada saat masuk",
select_file: "Pilih file",

description_movie: "video penjelasan",
how_to_use_movie: "Cara menggunakan video",
movie_news: "1. Berita tentang visa keterampilan khusus",
movie_exam: "2. Jumlah hari tersisa hingga tanggal tes",
movie_predict_pass: "3. Perkiraan tingkat kelulusan",
movie_ave_study_test: "4. Skor rata-rata dari tes Anda sendiri yang Anda pelajari",
movie_similar_exam: "5. Soal ujian serupa exam",
movie_learning_text: "6. Download buku pelajaran (textbook)",
movie_solved_exam: "7. Masalah yang saya pecahkan di masa lalu",
movie_pased_exam: "8. Tentang melihat masalah masa lalu yang sebenarnya muncul",
movie_resume_regist: "9. Lanjutkan pendaftaran pada saat masuk",
movie_pass_document_regist: "10. Pendaftaran kelulusan tes profisiensi",
movie_agency_service: "11. Layanan agen aplikasi ujian",
movie_consule_service: "12. Layanan konsultasi pembelajaran",
description_movie_trans: "Jika Anda ingin menonton dalam bahasa selain bahasa Jepang, klik tanda roda gigi, klik subtitle dan terjemahan otomatis, pilih bahasa asli Anda, lalu tonton.",

"cultivated_agriculture_general": "Budidaya pertanian pada umumnya",
"livestock_agriculture": "Pertanian ternak",
"介護": "perawatan",
"ビルクリーニング": "Pembersihan gedung",
"建設": "konstruksi",
"自動車整備": "Perawatan mobil",
"航空業": "Industri penerbangan",
"農業": "Pertanian",
"漁業": "Perikanan",
"飲食料品製造業": "Industri pembuatan makanan dan minuman",
"外食業": "Bisnis restoran",
"型枠施工": "Konstruksi bekisting",
"左官": "Tukang plester",
"コンクリート圧送": "Pemompaan beton",
"トンネル推進工": "Pekerjaan propulsi terowongan",
"建設機械施工": "konstruksi mesin konstruksi",
"大工": "tukang kayu",
"屋根ふき": "Tukang atap jerami",
"電気通信": "Teknisi telekomunikasi",
"鉄筋施工": "Teknisi konstruksi batang penguat",
"鉄筋継手": "Memperkuat metode sambungan batang",
"壁装　（壁張り）": "Teknik penutup dinding （Teknik dinding）",
"ボード仕上げ、内装仕上げ": "Konstruksi papan selesai.  Pekerjaan finishing interior",
"とび": "Pekerja (untuk pekerjaan teknik sipil dan konstruksi).  Juga, seorang pengrajin yang merakit bangunan di atas perancah yang tinggi.",
"吹き付けウレタン断熱": "Konstruksi insulasi uretan yang disemprotkan",
"海洋土木工": "Teknik sipil kelautan",
"航空機の基本技術 締結、電気計測": "Disimpulkan dengan teknologi dasar pesawat.  Pengukuran listrik",
"作業安全、品質": "Keselamatan kerja, kualitas",
"航空機概要": "Ikhtisar pesawat",
"耕種農業全般": "Budidaya pertanian pada umumnya",
"畜産農業": "Pertanian ternak",
"漁業一般": "Perikanan umum",
"漁業安全": "Keamanan Perikanan",
"漁業専門 綱関係": "Pakar perikanan.  Hubungan kelas",
"漁業専門 釣り関係": "Pakar perikanan.  Petugas perikanan",
"養殖業一般": "Akuakultur pada umumnya",
"養殖業専門 給餌養殖関係": "Ahli akuakultur.  Bisnis terkait pakan dan akuakultur",
"養殖業専門 無給餌養殖関係": "Ahli akuakultur.  Teknik terkait akuakultur yang tidak diberi makan",
"接客全般": "Layanan pelanggan umum",
"飲食物調理": "Memasak makanan dan minuman",
"衛生管理": "manajemen kebersihan",
"日本語版": "Versi bahasa Jepang",
"英語版": "versi bahasa Inggris",
"クメール語版": "Versi bahasa Khmer",
"インドネシア語版": "versi bahasa indonesia",
"インドネシア語・正誤表": "Bahasa Indonesia.  Daftar yang benar / salah",
"ネパール語版": "Versi bahasa Nepal",
"モンゴル語版": "Versi bahasa Mongolia",
"ビルマ語版": "Versi bahasa Burma",
"ベトナム語版": "versi bahasa Vietnam",
"タイ語版": "versi bahasa Thailand",
"テキスト１": "Teks 1",
"テキスト２": "Teks 2",
"テキスト３": "Teks 3",
"テキスト４": "Teks 4",
"テキスト５": "Teks 5",
"ミャンマー(ビルマ)語版": "Versi bahasa Myanmar (Burma)",
"カンボジア(クメール)語版": "Versi bahasa Kamboja (Khmer)",
"ミャンマー語版": "Versi Burma",
"中国語版": "versi bahasa Cina",
"付属資料": "Lampiran",
"用語集": "Glosarium",
"invitation_code": "Kode undangan",
"exam_calender": "Kalender jadwal ujian",
"move_exam_detail": "Apakah Anda ingin membuka halaman detail jadwal ujian?",
"move": "Pindah",
"plece_select_language": "Silakan pilih bahasa",
"select": "Pilih",
"midle_category": "Pekerjaan",
"select_industry_description": "Di AELU, Anda hanya dapat memilih hingga 3 industri di awal, jadi pilih hanya industri tempat Anda ingin bekerja.  Jika terlihat oke, tekan Next",
"done_member_regist_description_2": "Mulai sekarang, Kami di AELU juga akan mendukung Anda dalam mempersiapkan ujian sertifikasi dan mendapatkan visa keterampilan tertentu.",
"done_member_regist_2": "Pendaftaran anggota selesai.",
"is_exist_user": "Pengguna dengan alamat email yang sama sudah ada.",
"invitation_code_description": "(Masukkan kode undangan dari lembaga pengirim dan sekolah bahasa Jepang. Akan muncul layar penyelesaian pengeluaran, jadi jangan lupa untuk memasukkannya.)",
"pleace_select_region": "Silakan pilih prefektur yang akan dipegang.",
"pleace_add_messenger": "Semua kontak akan dikirim melalui Facebook messager.  Pastikan untuk menambahkannya.",
"add_messenger_bot": "Terima pemberitahuan",
"visa_application_description": "Lokasi penyimpanan dokumen yang diperlukan saat mengajukan visa keterampilan tertentu",
"check_agree": "Mohon setuju",
"sample_title": "Ini adalah judul boneka. Silakan atur",
"sample_description": "Ini adalah deskripsi boneka. Silakan atur. Ini adalah deskripsi boneka. Silakan atur. Ini adalah deskripsi boneka. Silakan atur. Ini adalah deskripsi boneka. Silakan atur. Ini adalah deskripsi boneka. Silakan atur. Ini adalah deskripsi boneka. Silakan atur. Ini adalah deskripsi boneka. Silakan atur.",
"create_profile_error": "Ada kesalahan dalam input. Silahkan cek barangnya",
"setting_confirm": "Silakan konfirmasi isi input dan daftar",
"exam_learning": "belajar ujian",
"recommend_problem_solve": "Memecahkan pertanyaan ujian serupa",
"of": "dari",
"see_solved_problem": "Memecahkan Pertanyaan yang telah diselesaikan sebelumnya \\ n",
"past_exam_collection": "Pertanyaan diajukan di masa lalu \\n  pertanyaan ujian",
"any_application_registration": "Berbagai aplikasi dan pendaftaran",
"mypage_visa_application": "Visa keterampilan khusus \\ n aplikasi",
"applyt_exam_and_agent": "Aplikasi ujian \\ n Aplikasi layanan agensi",
"myapge_regist_accept_certificate": "Tes keterampilan \\ nPendaftaran lulus",
"mypage_consultaion_service": "Konsultasi pembelajaran \\ n layanan",
"consult": "Berkonsultasi",
"of_exam_day": "Tanggal tes",
"your_ave_score": "Milik anda \\n Skor rata-rata untuk",
"your_estimated_pass_rate": "Milik anda\\ n perkiraan tingkat kelulusan Anda",
"your_ave_score_fotter": "Skor rata-rata untuk ujian Anda",
"your_estimated_pass_rate_fotter": "Perkiraan tingkat kelulusan",
"mypage_study_text": "Unduh buku teks pembelajaran \\ n",
"exam_schedule": "jadwal ujian",
"resident_caption_title": "● Tentang mengunggah kartu kependudukan atau KTP",
"resident_caption": "Harap unggah kartu kependudukan atau KTP yang dapat mengkonfirmasi informasi di bingkai merah. \\ nHarap unggah kartu kependudukan atau KTP yang masih berlaku yang belum kedaluwarsa. \\ nUnggah gambar berwarna dalam format PDF atau JPG.",
"password_caption_title": "● Tentang mengunggah kata sandi",
"password_caption": "Harap unggah gambar paspor yang mengonfirmasi nama / foto / nomor unik / tanggal lahir / kewarganegaraan / tanggal kedaluwarsa Anda seperti yang ditunjukkan dalam bingkai merah. \\ nHarap unggah paspor yang masih berlaku dan belum kedaluwarsa. \\ nUnggah gambar berwarna dalam format PDF atau JPG.",
"title_help": "Tolong",
"step3_title_help": "Silakan masukkan informasi Anda dengan benar.",
"lineid_input_help": "Buka LINE → Beranda → Pengaturan → Profil → Gulir untuk melihat ID. Silakan masukkan ID itu. Jika Anda belum membuatnya, silakan buat dan masukkan.",
"country_input_help": "Silakan pilih negara kebangsaan Anda.",
"area_input_help": "Pilih negara tempat Anda tinggal saat ini.",
"phone_input_help": "Masukkan nomor telepon anda.",
"issuing_input_help": "Silakan pilih area di mana ID Anda dikeluarkan.",
"idtype_input_help": "Silakan pilih jenis ID. Silakan ambil gambar yang indah dari orang yang dipilih dan unggah. Silakan menembak lurus sehingga tidak ada titik diagonal atau potong.",
"invitation_input_help": "Jika Anda memiliki kode undangan, masukkan.",
"exam_menu_help": "Akan ada pertanyaan yang mirip dengan pertanyaan yang sebenarnya ditanyakan di masa lalu. Memecahkan pertanyaan berulang untuk mempersiapkan ujian.",
"past_menu_help": "Anda akan memiliki masalah yang telah Anda pecahkan di masa lalu. Mari kita tinjau kesalahannya.",
"pastexam_menu_help": "Ini adalah teks soal ujian yang sebenarnya ada di masa lalu.",
"text_menu_help": "Anda dapat melihat buku pelajaran untuk mempelajari poin-poin penting dan mencari tahu apa yang tidak Anda pahami.",
"visa_menu_help": "Kami akan membantu Anda mendapatkan visa keterampilan khusus. Jika Anda ingin mendapatkan visa untuk keahlian tertentu, silakan mendaftar di sini.",
"agency_menu_help": "Kami akan mengajukan tes kecakapan khusus atas nama Anda. Jika Anda ingin mengikuti tes keterampilan tertentu, silakan mendaftar di sini.",
"cer_menu_help": "Jika Anda telah mengikuti tes kecakapan khusus dan memiliki sertifikat kelulusan, silakan mendaftar di sini.",
"service_menu_help": "Jika Anda memiliki pertanyaan atau masalah, silakan hubungi kami melalui obrolan di sini.",
"occu_title_help": "Silakan pilih hingga 3 pekerjaan yang diinginkan.",
"back": "kembali",
"before": "Untuk masalah sebelumnya",
srilank: "Srilanka",
reselect: "Jika Anda ingin mengubah file, tekan &quot;Unggah paspor Anda&quot; lagi dan pilih lagi",
iphone_file: "Untuk iphone, silakan gunakan setelah mengonversi dari file HEIC ke file JPG.",
file_transmit: "Konversi file",
combodia: 'combodia',
}
